import { makeObservable, observable, action, computed } from "mobx";
import { RootState, RootPayload, waiting, loading, ready } from "./Types";

class RootStore {
  state: RootState;

  constructor() {
    this.state = waiting();
    makeObservable(this, {
      state: observable,
      loading: action,
      ready: action
    });
  }

  loading = () => {
    this.state = loading();
  };

  ready = (rootPayload: RootPayload) => {
    this.state = ready(rootPayload);
  };
}

export default RootStore;
